import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  QueryList,
  ViewChildren
} from '@angular/core';
import { CarouselSwitchTypes, Contributor, ShowcasesEntity, ShowcasesTypes, } from 'search/full-card/models/showcases';
import { EntityTypes } from '../../../../../../entity/models/entity';
import { ContributorComponent } from '../contributor/contributor.component';
import { faAngleLeft, faAngleRight } from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'app-contributors',
  templateUrl: './contributors.component.html',
  styleUrls: ['./contributors.component.scss'],
})
export class ContributorsComponent implements OnChanges, AfterViewInit {
  @ViewChildren(ContributorComponent) public items: QueryList<ContributorComponent>;
  @Input() public contributors: Contributor[];
  @Input() public totalCount: number;
  @Input() public isLoading: boolean;
  @Input() public entity: ShowcasesEntity;
  @Input() public identifier: string;
  @Input() public showcaseId: string;
  @Output() public loadMore = new EventEmitter();
  public readonly arrowIconRight = faAngleRight;
  public readonly arrowIconLeft = faAngleLeft;
  public carouselItems: any;
  public isRightSwitchAvailable: boolean;
  public isLeftSwitchAvailable: boolean;
  public isAllContributorsLoaded: boolean;
  public isStart: boolean;
  public isEnd: boolean;
  public switchType: string;
  public isMouseEvent: boolean;
  public focusedId: string;
  public carouselChunkIndex = 0;
  public switchTypes = CarouselSwitchTypes;
  public title: string;
  public AGENT = EntityTypes.AGENT;
  public CONTRIBUTORS = ShowcasesTypes.CONTRIBUTORS;
  private readonly numColumns = 4;

  public constructor(
    private cdRef: ChangeDetectorRef,
  ) {
  }

  public ngOnChanges() {
    this.updateContributorsChunk();
  }

  public ngAfterViewInit() {
    this.items.changes.subscribe(() => {
      if (this.switchType === this.switchTypes.RIGHT) {
        this.focusedId = this.items.last.contributor.id;
      }
      if (this.switchType === this.switchTypes.LEFT) {
        this.focusedId = this.items.first.contributor.id;
      }
      this.cdRef.detectChanges();
    });
  }

  public switchCarouselRight(event: Event): void {
    event.stopPropagation();
    this.switchType = this.switchTypes.RIGHT;
    if (!this.isLoading) {
      this.carouselChunkIndex = this.isAllContributorsLoaded && this.isEnd ?
        0 : this.carouselChunkIndex + 1;
      if (this.contributors.length - this.carouselChunkIndex < this.numColumns && !this.isAllContributorsLoaded) {
        this.loadMore.emit(this.identifier);
      }
      this.updateContributorsChunk();
    }
  }

  public switchCarouselLeft(event: Event): void {
    event.stopPropagation();
    this.switchType = this.switchTypes.LEFT;
    this.carouselChunkIndex = this.carouselChunkIndex === 0 && this.isAllContributorsLoaded ?
      this.totalCount - 1 :
      this.carouselChunkIndex - 1;
    this.updateContributorsChunk();
  }

  public updateContributorsChunk(): void {
    const isSwitchAvailable = this.totalCount > this.numColumns;
    this.isAllContributorsLoaded = this.totalCount === this.contributors.length;
    this.isEnd = this.carouselChunkIndex === this.totalCount - 1;
    this.isStart = this.carouselChunkIndex === 0;

    this.carouselItems = this.contributors.slice(
      this.carouselChunkIndex,
      this.carouselChunkIndex + this.numColumns,
    );
    if (this.carouselItems.length < this.numColumns && isSwitchAvailable && this.isAllContributorsLoaded) {
      const endOfCarouselItems = this.contributors.slice(
        0,
        this.numColumns - this.carouselItems.length,
      );
      this.carouselItems = this.carouselItems.concat(endOfCarouselItems);
    }
    this.isRightSwitchAvailable = isSwitchAvailable;
    this.isLeftSwitchAvailable = isSwitchAvailable && (this.isAllContributorsLoaded || !this.isStart);
  }

  public toggleMouseEvent(value: boolean): void {
    this.isMouseEvent = value;
  }
}
